import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["data"];
import "core-js/modules/es.array.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useFieldArray } from '@isyc-react/form/modules/rhf';
import { ParameterState } from '@isyc-react/types';
import { defaultInputMultiParameterComponents } from "./components";
import { RhfInputParameter } from "./rhf-input-parameter.component";
export const RhfInputMultiParameter = props => {
  const {
    rhf,
    input,
    justify,
    parentKey,
    components = defaultInputMultiParameterComponents,
    showAddDeleteButtons,
    onChangeChildren
  } = props;
  const {
    control,
    name
  } = rhf;
  const {
      data
    } = input,
    rest = _objectWithoutProperties(input, _excluded);
  const {
    ParameterContainer = defaultInputMultiParameterComponents.ParameterContainer
  } = components;
  const {
    fields,
    insert,
    update,
    remove
  } = useFieldArray(_objectSpread(_objectSpread({}, rhf), {}, {
    keyName: 'rhfInternalId'
  }));
  const [onInsert, setOnInsert] = React.useState(false);
  const [onRemove, setOnRemove] = React.useState(false);
  const [onChangeChild, setOnChangeChild] = React.useState(false);
  React.useEffect(() => {
    if (onInsert) {
      onChangeChildren && onChangeChildren(fields);
      setOnInsert(false);
    }
  }, [fields, onInsert, onChangeChildren]);
  React.useEffect(() => {
    if (onRemove) {
      onChangeChildren && onChangeChildren(fields);
      setOnRemove(false);
    }
  }, [fields, onRemove, onChangeChildren]);
  React.useEffect(() => {
    if (onChangeChild) {
      onChangeChildren && onChangeChildren(fields);
      setOnChangeChild(false);
    }
  }, [fields, onChangeChild, onChangeChildren]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fields && fields.map((field, j) => {
    const child = field;
    return /*#__PURE__*/React.createElement(ParameterContainer, {
      parameter: child,
      showAddDeleteButtons: showAddDeleteButtons,
      key: `container-parameter-${parentKey}-${field['rhfInternalId']}`,
      onInsert: () => {
        const newChild = _objectSpread(_objectSpread({}, fields[j]), {}, {
          id: undefined,
          value: '',
          state: ParameterState.NO_VALIDATION,
          remarks: '',
          childrenParameters: undefined
        });
        insert(j + 1, newChild);
        setOnInsert(true);
      },
      onDelete: () => {
        remove(j);
        setOnRemove(true);
      },
      onChangeField: objectWithField => {
        update(j, _objectSpread(_objectSpread({}, fields[j]), objectWithField));
      }
    }, /*#__PURE__*/React.createElement(RhfInputParameter, {
      justify: justify,
      rhf: {
        control,
        name: `${name}.${j}`
      },
      input: _objectSpread(_objectSpread({}, rest), {}, {
        data: child
      }),
      key: child['rhfInternalId']
    }));
  }));
};